import React, { memo } from 'react';

import { CircularProgress, Grid, withStyles } from '@material-ui/core';

const FullheightGrid = withStyles({
  root: {
    height: '100%',
    minHeight: 240,
  },
})(Grid);

type Props = {
  size?: number;
  loadingClass?: string;
};

export const Loading = memo((props: Props) => (
  <FullheightGrid container justify="center" alignItems="center">
    <CircularProgress
      size={props.size ? `${props.size}px` : '6rem'}
      color="secondary"
      classes={{ root: props.loadingClass }}
    />
  </FullheightGrid>
));
